import React from 'react';
import {
  getLocalDemoProfiles,
  getSelectedLocalDemoProfileName,
  setSelectedLocalDemoProfileName,
  useAuthContext,
} from '../contexts/AuthContext';

const LocalDemoSwitcher: React.FC = () => {
  const profiles = getLocalDemoProfiles();
  const { permissions, sub } = useAuthContext();

  if (profiles.length === 0) return null;

  const selectedName = getSelectedLocalDemoProfileName() || profiles[0].name;
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    setSelectedLocalDemoProfileName(event.target.value);
    window.location.reload();
  };

  return (
    <div className="local-demo-switcher" aria-label="Local authorization demo identity">
      <label className="local-demo-switcher__label" htmlFor="local-demo-profile">Demo identity</label>
      <select id="local-demo-profile" value={selectedName} onChange={handleChange}>
        {profiles.map((profile) => (
          <option key={profile.name} value={profile.name}>
            {profile.label || profile.name}
          </option>
        ))}
      </select>
      <span className="local-demo-switcher__subject" title={sub ?? undefined}>
        {permissions.length > 0 ? permissions.join(' + ') : 'loading'}
      </span>
    </div>
  );
};

export default LocalDemoSwitcher;